import React, { useState, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import {
  makeStyles,
  Popover,
  Button,
  useMediaQuery,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { customTheme } from "../customTheme";
import moment from "moment";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
// import EventNoteIcon from '@material-ui/icons/EventNote';
// import DateRangeIcon from '@material-ui/icons/DateRange';
// import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    columnGap: 10,
    rowGap: 10,
  },
  chip: {
    margin: customTheme.spacing(0.5),
    fontFamily: "Poppins-Medium",
    fontSize: 12,
  },
  defaultSelector: {
    borderRadius: 10,
    backgroundColor: "#f2f2f2",
    color: "#888",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 8,
    padding: "12px 25px",
  },
  activeSelector: {
    backgroundColor: customTheme.palette.primary.main + "19",
    color: customTheme.palette.primary.main,
  },
  ampmSelector: {
    position: "absolute",
    bottom: 10,
    width: 38,
    height: 38,
    borderRadius: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 15,
    "&:hover": {
      cursor: "pointer",
    },
  },
  formControl: {
    minWidth: 100,
  },
  radioContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: customTheme.spacing(2),
  },
  radioInput: {
    marginRight: customTheme.spacing(1),
    padding: 0,
    appearance: "none",
    backgroundColor: "transparent",
    border: `2px solid ${customTheme.palette.primary.main}`,
    borderRadius: "50%",
    width: 16,
    height: 16,
    transition: "border-color 0.3s ease-in-out",
    "&:checked": {
      borderColor: customTheme.palette.secondary.main,
      backgroundImage: `radial-gradient(${customTheme.palette.secondary.main} 50%, transparent 51%)`,
    },
  },
  radioLabel: {
    fontFamily: "Poppins-Regular",
    fontSize: 14,
    color: customTheme.palette.text.primary,
  },
});

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div hidden={value !== index} {...other}>
//       {value === index && children}
//     </div>
//   );
// }

export default function CustomDateTimePickerV3(props) {
  const {
    startDateTime,
    setStartDateTime,
    endDateTime,
    setEndDateTime,
    onChange,
    limitDataRange,
    showOnlyCustomPicker = false,
    hideTillDateFilter = false,
    style,
  } = props;

  const PIKCER_TYPES = {
    MONTH: "Month",
    Quarter: "Quarter",
    Financial_Year: "Financial Year",
    Till_Date: "Till Date",
  };
  if(hideTillDateFilter) delete PIKCER_TYPES["Till_Date"]
  const classes = useStyles();
  const isSmallDevice = useMediaQuery((theme) =>
    customTheme.breakpoints.down("xs")
  );
  const [pickerType, setPickerType] = useState(
    showOnlyCustomPicker ? PIKCER_TYPES.Quarter : PIKCER_TYPES.MONTH
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [isTillDateSelected, setIsTillDateSelected] = useState(false);

  const quarterOptions = [
    { value: "Apr-Jun", label: "Q1: Apr-Jun" },
    { value: "Jul-Sep", label: "Q2: July-Sept" },
    { value: "Oct-Dec", label: "Q3: Oct-Dec" },
    { value: "Jan-Mar", label: "Q4: Jan-Mar" },
  ];

  const yearOptions = [];
  for (let year = 2011; year <= 2025; year++) {
    const nextYear = year + 1;
    yearOptions.push({
      value: `${year}-${nextYear}`,
      label: `${year}-${nextYear}`,
    });
  }

  const closePicker = () => {
    setAnchorEl(null);
  };

  const setYear = (yearRange) => {
    const [startYearStr, endYearStr] = yearRange.split("-");
    const startYear = parseInt(startYearStr);
    const endYear = parseInt(endYearStr);

    const newStartDate = new Date(startYear, 3, 1, 0, 0, 0); // April is month index 3
    const newEndDate = new Date(endYear, 2, 31, 23, 59, 58); // March is month index 2
    // console.log(newStartDate, newEndDate);
    setStartDateTime(moment(newStartDate).format("YYYY-MM-DD HH:mm:ss"));
    setEndDateTime(moment(newEndDate).format("YYYY-MM-DD HH:mm:ss"));
  };

  const setMonth = (dateMoment) => {
    const timeStr = sessionStorage.getItem("summary_start_time");
    const parsedTime = moment(timeStr, "HH:mm:ss");
    const hours = parsedTime.hours();
    const minutes = parsedTime.minutes();
    const seconds = parsedTime.seconds();

    setStartDateTime(
      moment(dateMoment, "YYYY-MM-DD HH:mm:ss")
        .startOf("month")
        .set({ hour: hours, minute: minutes, second: seconds })
        .format("YYYY-MM-DD HH:mm:ss")
    );
    setEndDateTime(
      moment(dateMoment, "YYYY-MM-DD HH:mm:ss")
       .set({ hour: 23, minute: 59, second: 59 })
       .endOf("month")
       .format("YYYY-MM-DD HH:mm:ss")
    );
    // setStartDateTime(dateMoment.startOf("month").toDate());
    // setEndDateTime(dateMoment.endOf("month").toDate());
  };

  const setQuarter = (quarterRange) => {
    const [startMonth, endMonth] = quarterRange.split("-");
    const currentYear = new Date().getFullYear();

    const startMonthIndex = moment().month(startMonth).month();
    const endMonthIndex = moment().month(endMonth).month();

    const newStartDate = new Date(currentYear, startMonthIndex, 1, 0, 0, 0);
    const newEndDate = new Date(currentYear, endMonthIndex + 1, 0, 23, 59, 58);
    // console.log(newStartDate,newEndDate);
    setStartDateTime(moment(newStartDate).format("YYYY-MM-DD HH:mm:ss"));
    setEndDateTime(moment(newEndDate).format("YYYY-MM-DD HH:mm:ss"));
  };

  // const scrollingTextHandler = () => {
  //   if (pickerType === PIKCER_TYPES.DATE) {
  //     if (
  //       startDateTime &&
  //       moment(startDateTime).calendar(null, {
  //         sameDay: "[Today]",
  //         nextDay: "[Tomorrow]",
  //         nextWeek: "Do MMMM' YY",
  //         lastDay: "[Yesterday]",
  //         lastWeek: "Do MMMM' YY",
  //         sameElse: "Do MMMM' YY",
  //       }).length > 5
  //     )
  //       return true;
  //     else return false;
  //   } else return false;
  // };

  const onListItemClick = (type) => {
    setPickerType(type);

    if (type === PIKCER_TYPES.Till_Date) {
      setIsTillDateSelected(true);
      closePicker();
    } else {
      setIsTillDateSelected(false);
    }
  };

  useEffect(() => {
    if (isTillDateSelected) {
      setStartDateTime(null);
      setEndDateTime(null);
      onChange();
    } else {
      onChange();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDateTime, endDateTime, isTillDateSelected]);

  return (
    <>
      <div
        style={{
          display: "flex",
          columnGap: 20,
          margin: isSmallDevice ? "0px 0px 0px 0px" : "0px 0px 0px 0px",
          padding: isSmallDevice ? "0px 0px" : "0 0",
          flexWrap: "wrap",
          rowGap: isSmallDevice ? 10 : 20,
          ...style,
        }}
      >
        <div
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
          }}
          className={`divButton ${classes.defaultSelector} ${
            classes.activeSelector
          }`}
        >
          <CalendarTodayIcon style={{ fontSize: 16 }} />

          {!showOnlyCustomPicker && (
            <div style={{ fontSize: 14 }}>
              <div
                className={
                  isTillDateSelected || pickerType === PIKCER_TYPES.Quarter
                    ? "scrolling-container"
                    : ""
                }
              >
                <div
                  className={
                    isTillDateSelected || pickerType === PIKCER_TYPES.Quarter
                      ? "scrolling-text"
                      : ""
                  }
                >
                  {isTillDateSelected
                    ? "Till Date"
                    : pickerType === PIKCER_TYPES.Quarter
                    ? selectedQuarter
                      ? moment(startDateTime).calendar(null, {
                          sameDay: "[Today]",
                          nextDay: "[Tomorrow]",
                          nextWeek: "Do MMMM' YY",
                          lastDay: "[Yesterday]",
                          lastWeek: "Do MMMM' YY",
                          sameElse: "Do MMMM' YY",
                        })
                      : moment().calendar(null, {
                          sameDay: "[Today]",
                          nextDay: "[Tomorrow]",
                          nextWeek: "Do MMMM' YY",
                          lastDay: "[Yesterday]",
                          lastWeek: "Do MMMM' YY",
                          sameElse: "Do MMMM' YY",
                        })
                    : pickerType === PIKCER_TYPES.MONTH
                    ? startDateTime
                      ? moment(startDateTime).format("MMMM' YY")
                      : moment().format("MMMM' YY")
                    : pickerType === PIKCER_TYPES.Financial_Year
                    ? startDateTime && endDateTime
                      ? `${moment(startDateTime).format(
                          "DD/MM/YYYY h:mm:ss A"
                        )} - ${moment(endDateTime).format(
                          "DD/MM/YYYY h:mm:ss A"
                        )}`
                      : `${moment().format(
                          "DD/MM/YYYY h:mm:ss A"
                        )} - ${moment().format("DD/MM/YYYY h:mm:ss A")}`
                    : PIKCER_TYPES[pickerType]}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={closePicker}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          style={{ marginTop: 15, width: isSmallDevice ? "100%" : "auto" }}
          id="custom-date-time-picker-v2"
        >
          <div
            style={{
              display: !isSmallDevice ? "flex" : "block",
              justifyContent: "flex-start",
              backgroundColor: "#F5F8FA",
              padding: !isSmallDevice ? 20 : "20px 20px 150px 20px",
              columnGap: 20,
              rowGap: 20,
            }}
          >
            {!isSmallDevice ? (
              <div>
                {Object.keys(PIKCER_TYPES)
                  .filter((type) =>
                    showOnlyCustomPicker && type === "MONTH"
                      ? type
                      : !showOnlyCustomPicker
                      ? type
                      : false
                  )
                  .map((value, i) => {
                    return (
                      <div key={value}>
                        <Button
                          onClick={() => onListItemClick(PIKCER_TYPES[value])}
                          variant="contained"
                          style={{
                            textTransform: "none",
                            fontSize: 13,
                            fontFamily: "Poppins-Regular",
                            letterSpacing: "0.06em",
                            width: "200px",
                            backgroundColor:
                              pickerType === PIKCER_TYPES[value]
                                ? "#707683"
                                : "#FFFFFF",
                            color:
                              pickerType === PIKCER_TYPES[value]
                                ? "#FFFFFF"
                                : "#90A0B7",
                            marginBottom: 20,
                            cursor: "pointer",
                            height: 45,
                            borderRadius: 10,
                            fontWeight: 500,
                          }}
                          disableElevation
                          startIcon={
                            <CalendarTodayIcon style={{ fontSize: 16 }} />
                          }
                        >
                          {PIKCER_TYPES[value]}
                        </Button>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <div style={{ backgroundColor: "#F5F8FA", padding: 10 }}>
                <div className={classes.root}>
                  {Object.keys(PIKCER_TYPES)
                    .filter((type) =>
                      showOnlyCustomPicker && type === "MONTH"
                        ? type
                        : !showOnlyCustomPicker
                        ? type
                        : false
                    )
                    .map((value, i) => {
                      return (
                        <div key={value}>
                          <Button
                            onClick={() => onListItemClick(PIKCER_TYPES[value])}
                            variant="contained"
                            style={{
                              textTransform: "none",
                              fontSize: 13,
                              fontFamily: "Poppins-Regular",
                              letterSpacing: "0.06em",
                              backgroundColor:
                                pickerType === PIKCER_TYPES[value]
                                  ? "#707683"
                                  : "#FFFFFF",
                              color:
                                pickerType === PIKCER_TYPES[value]
                                  ? "#FFFFFF"
                                  : "#90A0B7",
                              marginBottom: 20,
                              cursor: "pointer",
                              height: 45,
                              borderRadius: 10,
                              fontWeight: 500,
                            }}
                            disableElevation
                            startIcon={
                              <CalendarTodayIcon style={{ fontSize: 16 }} />
                            }
                          >
                            {PIKCER_TYPES[value]}
                          </Button>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
            {pickerType === PIKCER_TYPES.Quarter && (
              <div className={classes.formControl}>
                <div className={classes.select}>
                  <div className={classes.radioOptions}>
                    {quarterOptions.map((quarterOption) => (
                      <div
                        key={quarterOption.value}
                        className={classes.radioContainer}
                      >
                        <input
                          type="radio"
                          id={`quarter_${quarterOption.value}`}
                          value={quarterOption.value}
                          checked={selectedQuarter === quarterOption.value}
                          onChange={(event) => {
                            const selectedQuarterValue = event.target.value;
                            setSelectedQuarter(selectedQuarterValue);
                            if (pickerType === PIKCER_TYPES.Quarter) {
                              setQuarter(selectedQuarterValue);
                            }
                            closePicker();
                          }}
                          className={classes.radioInput}
                        />
                        <label
                          htmlFor={`quarter_${quarterOption.value}`}
                          className={classes.radioLabel}
                        >
                          {quarterOption.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {!showOnlyCustomPicker && pickerType === PIKCER_TYPES.MONTH && (
              <div className="customPickersStyles">
                <DatePicker
                  variant="static"
                  minDate={
                    limitDataRange > 0
                      ? moment()
                          .subtract(limitDataRange - 1, "days")
                          .toDate()
                      : undefined
                  }
                  disableFuture
                  disableToolbar={pickerType !== PIKCER_TYPES.MONTH}
                  value={startDateTime}
                  onChange={(date) => {
                    const dateMoment = moment(date);
                    if (pickerType === PIKCER_TYPES.MONTH) {
                      setMonth(dateMoment);
                    }
                    closePicker();
                  }}
                  views={["month", "year"]}
                />
              </div>
            )}
            {!showOnlyCustomPicker &&
              pickerType === PIKCER_TYPES.Financial_Year && (
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <RadioGroup
                    aria-label="Year"
                    name="year"
                    value={selectedYear}
                    onChange={(event) => {
                      const selectedYearValue = event.target.value;
                      setSelectedYear(selectedYearValue);
                      if (pickerType === PIKCER_TYPES.Financial_Year) {
                        setYear(selectedYearValue);
                      }
                      closePicker();
                    }}
                  >
                    {yearOptions.map((yearOption) => (
                      <FormControlLabel
                        key={yearOption.value}
                        value={yearOption.value}
                        control={<Radio />}
                        label={yearOption.label}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              )}
          </div>
        </Popover>
      </MuiPickersUtilsProvider>
    </>
  );
}
